import { Component, OnInit } from '@angular/core';
import {LogsService} from '../../services/logs.service';
import {DatesParserService} from '../../../../../core/service/dates_parser.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';

import * as moment from 'moment';
import {LocalDataSource} from 'ng2-smart-table';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';

import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import * as _ from 'underscore';
import {AuthService} from '../../../../../core/service/auth.service';


@Component({
  selector: 'app-list-logs',
  templateUrl: './list-logs.component.html',
  styleUrls: ['./list-logs.component.scss']
})
export class ListLogsComponent implements OnInit {

    logs: LocalDataSource;
    pkService: number;
    enabled: boolean;
    submitted: true;

    formSearch: FormGroup;
    settings: Object;
    errors: Object;

    extraHeaders: Array<string> = [];

    fromHr:any;
    toHr:any;

    constructor(private logsManager: LogsService, private datesParser: DatesParserService, private auth: AuthService, private messaging: MessagingService) {
        let from= new Date();
        from.setHours(0,0,0,0);
        this.fromHr=from;
        let to= new Date();
        to.setHours(23,59,59,0);
        this.toHr=to;

        this.logs = new LocalDataSource();
        this.errors = {};
        this.formSearch = new FormGroup(
            {
                'start_date' : new FormControl('', Validators.required),
                'end_date' : new FormControl('', Validators.required),
                'alias_verification' : new FormControl('', Validators.required),
                'extra_campaign': new FormControl(),
                'extra_action': new FormControl(),
                'response' : new FormControl(),
                'extra_like' : new FormControl(),
                'ignore_failovers' : new FormControl()
            }
        );

        this.settings = {
            columns: {
                pk: {title: '#'},
                lang: {title: 'Lang', width: '5%'},
                pk_client: {title: 'Pk client'},
                pk_campaign: {title: 'Pk campaign'},
                created_at: {title: 'Created at'},
                delayed_to: {title: 'Delayed to'},
                timezone: {title: 'Timezone'},
                call_provider: {title: 'Call provider'},
                element: {title: 'Phone'},
                element_norm: {title: 'Phone norm'},
                phone_type: {title: 'Phone type'},
                response: {title: 'Response'},
                status: {title: 'Status'},
            },
            attr: {
                class: 'table table-bordered'
            },
            actions: {
                add: false,
                delete: false,
                edit: false
            }
        };
    }

    ngOnInit() {
        this.messaging.message.subscribe(
            (msg: any) => {
                if(msg instanceof VnaPortalSelected && !msg.isTheFirst()){
                    this.formSearch.controls['extra_campaign'].setValue('');
                    this.formSearch.controls['extra_action'].setValue('');

                    this.findLogs();
                }
            }
        )
    }

    findLogs() {

        if(!this.formSearch.valid){
            this.submitted = true;
            return;
        }

        this.enabled = true;
        this.pkService = this.formSearch.value.alias_verification;
        let query = this.datesParser.cleanDates(this.formSearch.value, ['start_date', 'end_date'], false);

        delete query['alias_verification'];
        this.logsManager.findLogs(this.auth.getPkPortal(), this.pkService, query).subscribe(
            result => {
                if(result.hasOwnProperty('errors')){
                    this.errors = result['errors']
                }
                else{
                    this.logs.load(result);
                    if(this.logs.count() > 0 && !_.isEmpty(result[0].extra) ) {
                        this.extraHeaders = _.keys(result[0].extra);

                    }
                }

                this.enabled = false;
            }
        )
    }

    logsToCsv(): void {
        this.logs.getFilteredAndSorted().then(
            (result) => {
                let headers = _.keys(this.settings['columns']);
                if(this.extraHeaders.length > 0){
                    headers = _.union(headers, this.extraHeaders)
                }
                let finalResult = _.map(result, (o) => {
                    let row: Object = o;
                    let extra = row['extra'];
                    delete row['extra'];
                    _.each(extra, (value, key) => { row[key] = value; });

                    return row;
                });
                new Angular2Csv(result, 'logs_report_' + moment().unix(), {
                    'showLabels' : true,
                    'headers' : headers
                });
            }
        );

    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/logs/components/list-logs/list-logs.component.ts